/* eslint-disable import/prefer-default-export */
import * as Actions from './constants';

export const changeSelectedYear = (year: number) => ({ type: Actions.CHANGE_SELECTED_YEAR, payload: year });
